import { HashLink } from 'react-router-hash-link'

export default HashLink
